import { render, staticRenderFns } from "./HighlightColorButton.vue?vue&type=template&id=97783f64"
import script from "./HighlightColorButton.vue?vue&type=script&lang=js"
export * from "./HighlightColorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports